import { Product } from "../../../tendercuts/models/catalog";

export class OutofStockProducts {
  itemid: number;
  quantity: number;
  status: string;

  constructor() {}

  deserialize(input) {
    this.itemid = input.entity_id;
    this.quantity = input.qty;
    return this;
  }
}
